module.exports = __webpack_public_path__ + "static/318408708_666023135194125_920671561452868595_n.jpg-1671186393225-a9c8c27abb92fca7876eb935c586086a.webp";